import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// import './index.css';

// Créer la racine avec la nouvelle API de React 18
const root = ReactDOM.createRoot(document.getElementById('root'));

// Utiliser `root.render()` au lieu de `ReactDOM.render()`
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Mesurer les performances (si nécessaire)
reportWebVitals();
